const FROM_KEY = (obj: any, key: string) => obj[key];

export default FROM_KEY;

export const FROM_KEY_VALUE_PAIRS = (data: any, key: string) => {
  const { _data: pairList } = data;
  return pairList.find(([pairKey]: any) => pairKey === key)?.[1];
};
